import { C_ASSOCIATES_TYPES } from "@/src-refactor/modules/shared/model/const/property/associates-types.conts";
import { C_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import HCheckArray from "@rf-helper/check-have-value";

export const enumKeyFormPropery = {
  isEdit: "is_edit",
  isProject: "is_project",
  typeProperty: "type_property",
  businessTypes: "business_types_property"
};

export const fileIsRequiredWhenIsRent = (fileName: string) => {
  return [
    "file_owner_id_property",
    "file_application_form_property",
    "file_capture_details_property"
  ].includes(fileName);
};

export const checkTypeRent = (
  business_types_property: I_GENERIC_ITEMS[],
  is_project: boolean
) =>
  HCheckArray(business_types_property) &&
  [C_BUSINESS_TYPE.SELL.value, C_BUSINESS_TYPE.SALE_AND_SELL.value].includes(
    business_types_property[0].value
  ) &&
  !is_project;

export const checkTypeSale = (
  business_types_property: I_GENERIC_ITEMS[],
  is_project: boolean
) =>
  HCheckArray(business_types_property) &&
  [C_BUSINESS_TYPE.SALE.value, C_BUSINESS_TYPE.SALE_AND_SELL.value].includes(
    business_types_property[0].value
  ) &&
  !is_project;

export const checkIsProject = (is_project: boolean) => is_project;

export const checkTypeIsNoBroker = (associates_type_property: I_GENERIC_ITEMS[]) =>
  HCheckArray(associates_type_property) &&
  [C_ASSOCIATES_TYPES.NO_BROKER.value].includes(associates_type_property[0].value);

export const checkTypeProperty = ({
  typePropertyValue,
  isProjectValue,
  propertyTypeIds,
  projectTypeIds
}: {
  typePropertyValue: I_GENERIC_ITEMS[];
  isProjectValue: boolean;
  propertyTypeIds: number[];
  projectTypeIds: number[];
}) => {
  if (isProjectValue) {
    return (
      HCheckArray(typePropertyValue) &&
      projectTypeIds.includes(typePropertyValue[0].id)
    );
  }
  return (
    HCheckArray(typePropertyValue) &&
    propertyTypeIds.includes(typePropertyValue[0].id)
  );
};

const uniqueYoutubeUrls = (value: string[]) => {
  if (!value) {
    return true;
  }
  if (value.filter(x => x.length > 0).length === 0) {
    return true;
  }
  const urlSet = new Set(value);
  return urlSet.size === value.length;
};
